import { gql } from '@apollo/client';

// 更新使用者Email
export const UPDATE_USER_EMAIL = gql`
  mutation UpdateUserEmail($input: UpdateEmailInput!) {
    updateUserEmail(input: $input) {
      success
      message
      user {
        id
        username
        email
      }
      errors {
        field
        message
      }
    }
  }
`;

// 更新使用者密碼
export const UPDATE_USER_PASSWORD = gql`
  mutation UpdateUserPassword($input: UpdatePasswordInput!) {
    updateUserPassword(input: $input) {
      success
      message
      user {
        id
        username
      }
      errors {
        field
        message
      }
    }
  }
`;

// 更新名稱
export const UPDATE_USERNAME = gql`
  mutation UpdateUsername($input: UpdateUsernameInput!) {
    updateUsername(input: $input) {
      success
      message
      user {
        id
        username
        email
      }
      errors {
        field
        message
      }
    }
  }
`;

// 更新上線狀態
export const UPDATE_ONLINE_STATUS = gql`
  mutation UpdateOnlineStatus {
    updateOnlineStatus
  }
`;

// 獲取當前使用者資訊
export const GET_ME = gql`
  query GetMe {
    me {
      id
      username
      email
      isActive
      profileOpen
      status
      isSemiAdmin
      isVerified
      lastLogin
      lastOnlineAt
      createdAt
      updatedAt
      authProvider
      googleId
    }
  }
`;

